export const PAYMENT_STATUS_NOT_PAID = '1'
export const PAYMENT_STATUS_PAID = '2'

export const PAYMENT_IN = 1
export const PAYMENT_OUT = 2
